module.exports = __webpack_public_path__ + "img/Stop-Logo.f5dfc618.png";